import { useEffect } from 'react';
import * as L from 'leaflet';
import { useMapStore } from '../MapStore/UseMapStore';
import {
  createStandardIcon,
  handleItemClick,
  handleStandardHover,
  handlePopupAndMenuOverlap,
  updateMarkerSizes,
} from '../MapFunctions/MapHelperFunctions';

export function useGatewaysLayer() {
  const gatewayFC = useMapStore((s) => s.gatewayFC);
  const gatewayLayer = useMapStore((s) => s.gatewayLayer);
  const setGatewayLayer = useMapStore((s) => s.setGatewayLayer);
  const setGatewayRefLayer = useMapStore((s) => s.setGatewayRefLayer);

  const showInfo = useMapStore((s) => s.showInfo);
  const setSelected = useMapStore((s) => s.setSelected);
  const setClickEvent = useMapStore((s) => s.setClickEvent);
  const setShowInfo = useMapStore((s) => s.setShowInfo);
  const setShowMore = useMapStore((s) => s.setShowMore);
  const markerSize = useMapStore((s) => s.markerSize);

  useEffect(() => {
    if (!gatewayLayer) return;

    // Clear old layers
    gatewayLayer.clearLayers();
    setGatewayRefLayer(null);

    if (!gatewayFC) return;

    // Create GeoJSON layer with click handling
    const curGateways = new L.GeoJSON(gatewayFC, {
      onEachFeature(feature, layer) {
        handleItemClick(
          feature,
          layer,
          'gateway',
          showInfo,
          setSelected,
          handlePopupAndMenuOverlap,
          setClickEvent,
          setShowInfo,
          setShowMore,
        );
        handleStandardHover(layer);
      },
      pointToLayer: (feature, latlng) => createStandardIcon(feature, latlng, 'gateway', markerSize),
    });

    // Add to cluster layer and build reference map
    const newRef: Record<string, L.Layer> = {};
    curGateways.eachLayer((layer) => {
      newRef[layer.feature.properties.Id] = layer;
      gatewayLayer.addLayer(layer);
    });

    setGatewayLayer(gatewayLayer);
    setGatewayRefLayer(newRef);
  }, [
    gatewayFC,
    gatewayLayer,
    showInfo,
    setGatewayLayer,
    setGatewayRefLayer,
    setSelected,
    setClickEvent,
    setShowInfo,
    setShowMore,
  ]);

  useEffect(() => {
    updateMarkerSizes(gatewayLayer, 'gateway', markerSize);
  }, [markerSize, gatewayLayer]);
}
